import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../section/user/service/user.service';
import { SharedService } from '../../../component/shared/shared.service';
import { UserDetail } from '../model/user-detail';
import { Patient } from '../../../section/patient/model/patient';


@Component({
  selector: 'app-msk',
  templateUrl: './msk.component.html',
  styleUrls: ['./msk.component.css']
})
export class MskComponent implements OnInit {
  userService : UserService;
  type: number =0;  
  feedbacks: any = [];
   selectedFeedback: any = null;
  isEdit: boolean = false;
  text: string="";
  constructor(private _sharedService: SharedService,private _UserService: UserService,) {
     
 
   }

  ngOnInit() {
    
    this.getFeedback(0);
  }
   
  ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
 
  getFeedback(status: number) : void {
     this.type = status;
     this._UserService.getFeedback().subscribe(data=>{
       if(status != 2) {
        this.feedbacks = data.filter(x=> x.Status==status);
       } else {
        this.feedbacks = data;
       }     
     },error=>{

     });
  }
  deleteFeedback(id: number) {

    this._UserService.DeleteFeedback(id).subscribe(data=>{
        
         this.getFeedback(this.type);
     },error=>{

     });
  }
 
  verifyFeedback(feedback: any) {
    this._UserService.UpdateFeedbackStatus(feedback).subscribe(data=>{
        
         this.getFeedback(this.type);
     },error=>{

     });
  }

  EditFeedback(feedback: any) {
    this.isEdit = true;
    this.selectedFeedback = feedback;
    this.text = this.selectedFeedback.PatientMessage;
  }
  
  saveText() {
    let data = {'PatientMessage' : this.text, "FeedbackId" : this.selectedFeedback.FeedbackId}
    this._UserService.UpdateFeedback(data).subscribe(data=>{
      this.isEdit = false;
      this.getFeedback(this.type);
  },error=>{

  });
  }

}



// WEBPACK FOOTER //
// ./src/app/section/user/msk/msk.component.ts